<div class="modal-header">
  <h4 class="modal-title pull-left">
    {{ 'projectDirectOrderPopup.title' | translate }}
  </h4>
  <button aria-label="Close"
          class="close pull-right"
          type="button"
          (click)="close()"><span aria-hidden="true">×</span></button>
</div>

<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <p *ngIf="!!projectSaveInfo" [innerHTML]="getInfoMessage()"></p>
    <div *ngIf="directlyOrderableVersionExists">
      <div [innerHTML]="getArticleNumberLongLabel()"></div>
      <div [innerHTML]="getProjectVersionDisplayStringLabel()"></div>
    </div>
    <p *ngIf="!!projectSaveInfo"></p>
  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-secondary btn-cancel" (click)="close()">
    {{'global.label.cancel' | translate}}
  </button>
  <button *ngIf="directlyOrderableVersionExists" class="btn btn-primary btn-forward" appActionLogId="direct_order.executed" (click)="order()">
    {{'global.label.continue' | translate}}
  </button>
</div>
